module.exports = __webpack_public_path__ + "static/work18-84bdd01ee200d7b37058e3a425361912.jpg";